module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_4.e2bb4b4f.png";